/* src/app/components/portfolio-info/portfolio-info.component.scss */
.container-title {
  padding: 1.125rem 1rem;
  border: 0.0625rem solid rgba(46, 46, 56, 0.08);
  display: inline-flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}
.container-title .title {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #2e2e38;
  margin: 0;
}
.container-title .subtitle {
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 300;
  color: #72727f;
  margin: 0;
}
.container-title .subtitle-wrapper {
  display: flex;
}
.container-title .delete-btn {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #89251c;
  margin-left: 1rem;
}
.container-title .ic-delete {
  font-size: 1.5rem;
  line-height: 1.5rem;
  color: #89251c;
}
.edit {
  display: inline-flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  opacity: 1;
  border: 0.0625rem solid rgba(46, 46, 56, 0.08);
  font-size: 0.75rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: rgba(114, 114, 127, 0.32);
  margin-top: 0;
}
.edit.hidden {
  opacity: 0;
  border: none;
  position: absolute;
  left: -99999;
}
.container-title-aggregation {
  padding: 0.75rem 1rem;
  background-color: #FAFAFA;
}
.container-title-aggregation .title-subtitle {
  line-height: 1rem;
}
.container-config {
  padding: 1rem 1rem;
  margin-bottom: 1.5rem;
  border: 0.0625rem solid rgba(46, 46, 56, 0.08);
  border-top: none;
}
.container-config .config {
  align-items: center;
  margin-top: 0.5rem;
}
.container-config .config:first-child {
  margin-top: 0;
}
.container-config .config .name {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: rgba(46, 46, 56, 0.64);
  margin: 0;
}
.container-config .config .name-container {
  flex: 1;
}
.invalid {
  color: #89251c !important;
  font-size: 1.25rem;
  line-height: 1.25rem;
}
.invalid-message {
  font-size: 0.75rem;
  line-height: 0.875rem;
  font-weight: 300;
  color: #89251c;
  margin-top: -0.75rem;
  margin-left: 0.75rem;
}
/*# sourceMappingURL=portfolio-info.component.css.map */
